module.exports = __webpack_public_path__ + "img/Gibraltar.3d43d9a5.svg";